import React, { Fragment, useEffect, useRef, useState } from 'react';
// Import Swiper React component
import { Swiper, SwiperSlide } from 'swiper/react';
import { bannerList } from '@/api/server/common/bannerList';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './BannerList.css';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper';
import { viewFileById } from '@/api/server/common/viewFile';
import ErrorRes from '@/api/server/ErrorRes';
import Banner from '../common/banner';
import Box from '@mui/material/Box';

export default function BannerList() {
  const [list, setList] = useState<any[]>();
  // 배너리스트
  useEffect(() => {
    (async () => {
      const re = await bannerList();
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setList(re.data);
    })();

    return () => {};
  }, []);
  return (
    <Box>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false} // 좌우 화살표
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {list?.map((item: any, index) => (
          <Fragment key={item.banner_id + index}>
            <SwiperSlide>
              <Banner
                // category="EVENT"
                slide={true}
                src={item.asset_url}
                // title={item.title}
                mb={3}
                buttonProps={{
                  sx: {
                    width: '100%',
                  },
                }}
                onClick={() => {
                  document.location = item.link_url;
                }}
              />
            </SwiperSlide>
          </Fragment>
        ))}
      </Swiper>
    </Box>
  );
}
